export const INDICACIONES_LIST = "INDICACIONES_LIST";